"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _Heading = require("../Heading/Heading");

var _Card = _interopRequireDefault(require("../Card/Card"));

var _Paragraph = _interopRequireDefault(require("../Paragraph/Paragraph"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _excluded = ["title", "subtitle", "content", "action"];

var PromotionCard = function PromotionCard(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      content = _ref.content,
      action = _ref.action,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Card["default"], (0, _extends2["default"])({
    p: 3,
    justifyContent: "center",
    alignItems: "center",
    width: 1 / 1
  }, props), title && /*#__PURE__*/_react["default"].createElement(_Heading.H3, {
    fontWeight: "500",
    mb: 3,
    fontSize: 4
  }, title), subtitle && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    fontSize: 3,
    fontWeight: "500",
    color: "dark.2",
    mb: 3
  }, subtitle), content && content.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      fontSize: 3,
      color: "dark.2",
      mb: 3,
      key: item
    }, item);
  }), action && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, action.label && /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    fontSize: 2,
    color: "dark.2",
    mb: 2
  }, action.label), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    width: 1 / 1,
    variant: action.colour || "secondary.0",
    elevation: 4,
    onClick: action.onClick
  }, action.description)));
};

var _default = PromotionCard;
exports["default"] = _default;